import { tryParseJson } from '../json';
import { isArray } from 'lodash-es';

/**
 * 安全解析 resource.form JSON 字符串为表单节点数组
 * 解析失败或非数组时返回空数组
 */
export const tryParseForm = (form?: string) => {
	if (!form) return [];

	const formArray = tryParseJson(form);
	if (!isArray(formArray)) return [];

	return formArray;
};
